<template>
  <div v-if="user">
    <div class="tab__Item">
      <error-prompt class="error--Modal" :errors="errors"></error-prompt>
      <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

      <div class="formSection" v-if="loading === false">
        <user-fields v-model="item" :user="item" :loading="loading" />

        <div class="formSection__Row--Group">
          <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('email') }}</label>
          <div class="formSection__Columns--Editor">
            <input
              v-model="item.email"
              disabled
              class="formInput--Scrape"
              type="email"
              id="email"
              autocomplete="new-password"
            />
            <button
              type="button"
              @click="
                changeProp(
                  'request_email_change',
                  { email: item.email },
                  'A confirmation link has been sent to your e-mail.'
                )
              "
              class="button--Scrape"
            >
              {{ $store.getters.getStringTranslation('chageEmail') }}
            </button>
          </div>
        </div>

        <div class="formSection__Row--Group">
          <template v-if="changePassword === false">
            <label class="formLabel" for="fakePassword">{{ $store.getters.getStringTranslation('password') }}</label>
            <div class="formSection__Columns--Editor">
              <input disabled class="formInput--Scrape" type="password" id="fakePassword" value="password" />
              <button type="button" @click="changePassword = true" class="button--Scrape">
                {{ $store.getters.getStringTranslation('changePass') }}
              </button>
            </div>
          </template>

          <template v-else>
            <div class="formSection__Columns--Password">
              <div class="formSection__Column--Tight">
                <label class="formLabel" for="old_password">{{ $store.getters.getStringTranslation('oldPass') }}</label>
                <input v-model="item.old_password" class="formInput--Scrape" type="password" id="old_password" />
              </div>

              <div class="formSection__Column--Tight">
                <label class="formLabel" for="password">{{ $store.getters.getStringTranslation('newPass') }}</label>
                <input v-model="item.password" class="formInput--Scrape" type="password" id="password" />
              </div>
            </div>
            <p class="note">{{ $store.getters.getStringTranslation('leaveBothFieldsBlank') }}</p>
          </template>

          <button
            type="button"
            :disabled="item.old_password.length === 0 || item.password.length === 0"
            @click="
              changeProp(
                'user/update_password',
                { password: item.password, old_password: item.old_password },
                'Password changed successfully.'
              )
            "
            class="button--Scrape"
          >
            {{ $store.getters.getStringTranslation('updatePass') }}
          </button>
        </div>

        <div class="formSection__Columns--Spread">
          <p>
            <button type="button" @click="deleteAccount()" class="button--DeleteAccount">
              {{ $store.getters.getStringTranslation('deleteAcc') }}
              <icon name="trash-alt" />
            </button>
          </p>
          <p>
            <button
              @click="changeProp('user/update', item, 'Success! Your account has been updated.')"
              :disabled="updated === true"
              class="button"
            >
              {{ $store.getters.getStringTranslation('saveSettings') }}
            </button>
          </p>
        </div>
      </div>
    </div>
    <loader class="imageLoader" :loading="loading || updating" />
  </div>
</template>

<script>
import HTTP from '@/http-common.js'
import Loader from '@/components/partials/Loader.vue'
import UserFields from '@/components/editor/UserFields.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'

export default {
  name: 'Account',
  components: {
    Loader,
    UserFields,
    SuccessPrompt,
    ErrorPrompt,
  },
  data() {
    return {
      item: {
        email: '',
        name: '',
        password: '',
        old_password: '',
        l10n: [
          {
            position: '',
            description: '',
            lang: this.$store.state.ui.lang,
            contents: [],
          },
        ],
        contents: {
          thumbnail_urls: {},
          additionals: {
            phone: '',
            facebook: '',
            twitter: '',
            medium: '',
          },
        },
      },
      user: null,
      changePassword: false,
      updating: false,
      loading: false,
      prompt: {
        success: '',
      },
      updated: false,
      errors: [],
    }
  },
  watch: {
    item: {
      handler() {
        this.errors = []
      },
      deep: true,
    },
  },
  mounted() {
    // Load user and org data
    this.user = JSON.parse(JSON.stringify(this.$store.state.accounts.user))
    this.item.email = this.user.email
    this.item.name = this.user.name

    this.loading = true
    HTTP.get(`user/my_account`)
      .then((response) => {
        this.item = response.data
        this.$set(this.item, 'password', '')
        this.$set(this.item, 'old_password', '')
        if (this.item.l10n === undefined || this.item.l10n.length === 0)
          this.item.l10n = Object.assign([], this.item.l10n, [
            { position: '', description: '', lang: this.$store.state.ui.lang, contents: [] },
          ])
        if (this.item.contents.additionals === undefined)
          this.item.contents.additionals = Object.assign({}, this.item.contents.additionals, {
            phone: '',
            facebook: '',
            twitter: '',
            medium: '',
          })

        this.loading = false
      })
      .catch((e) => {
        if (e.response) this.errors = e.response ? e.response.data : console.error(e)
        this.loading = false
      })
  },
  methods: {
    changeProp(route, obj, message) {
      this.updating = true
      HTTP.post(route, obj)
        .then((response) => {
          if (route === 'user/update') this.$store.dispatch('updateUser', response.data)
          this.user = JSON.parse(JSON.stringify(this.$store.state.accounts.user))
          this.updating = false
          this.updated = true
          this.prompt.success = message

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)
        })
        .catch((e) => {
          console.log(e)
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
        })
    },
    deleteAccount() {
      if (
        confirm(
          `Are you sure you wish to delete your account? All your contributed resources will remain but no user will be assigned to them. This action is permanent!`
        )
      ) {
        this.loading = true

        HTTP.delete(`user/my_accounts`).then(() => {
          this.updated = true
          this.loading = false
          this.prompt.success = 'Success! Your account has been removed. We will now redirect you.'

          // Enable edit
          setTimeout(() => {
            localStorage.removeItem('token')
            this.$store.dispatch('updateUser', { name: '', email: '' })
            this.$router.push({ path: '/login' })
          }, 3000)
        })
      }
    },
  },
}
</script>
